import { createSlice } from "@reduxjs/toolkit";

export interface NavItemAPI  {
  path: string,
  label: string,
}

type InitialState = {
  items: Array<NavItemAPI>,
}

export enum PATH_NAME {
  HOME = 'Resumen',
  SURVEYS = 'Encuestas',
  SURVEY_VIEW = 'Detalles de la encuesta',
  SURVEY_EDIT = 'Editar encuesta',
  SURVEY_APPLY = 'Aplicar encuesta',
  SURVEY_CREATE = 'Nueva encuesta',
  STATISTICS = 'Estadísticas',
  USERS = 'Colaboradores',
  USER_VIEW = 'Detalles del colaborador',
  USER_EDIT = 'Editar colaborador',
  USER_CREATE = 'Nuevo colaborador',
  SECTIONS = 'Secciones',
  SETTINGS = 'Ajustes',
  NOT_FOUND = '',
};

export const paths = [{
  path: '/',
  label: PATH_NAME.HOME,
}, {
  path: '/encuestas',
  label: PATH_NAME.SURVEYS,
}, {
  path: '/encuestas/:id',
  label: PATH_NAME.SURVEY_VIEW,
}, {
  path: '/encuestas/:id/editar',
  label: PATH_NAME.SURVEY_EDIT,
}, {
  path: '/encuestas/:id/aplicar',
  label: PATH_NAME.SURVEY_APPLY,
}, {
  path: '/encuestas/crear',
  label: PATH_NAME.SURVEY_CREATE,
}, {
  path: '/estadisticas',
  label: PATH_NAME.STATISTICS,
}, {
  path: '/colaboradores',
  label: PATH_NAME.USERS,
}, {
  path: '/colaboradores/:id',
  label: PATH_NAME.USER_VIEW,
}, {
  path: '/colaboradores/:id/editar',
  label: PATH_NAME.USER_EDIT,
}, {
  path: '/colaboradores/nuevo',
  label: PATH_NAME.USER_CREATE,
}, {
  path: '/secciones',
  label: PATH_NAME.SECTIONS,
}, {
  path: '/ajustes',
  label: PATH_NAME.SETTINGS,
}, {
  path: '*',
  label: PATH_NAME.NOT_FOUND,
}];

const initialState: InitialState = {
  items: paths,
};

const NavigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setNavigation: (state, action) => {
      state.items = action.payload;
    },
  },
});

export const { actions, reducer } = NavigationSlice;
